const prepareOutsideLink = (link) => {
  const regExp = new RegExp(/https?/gm);
  let matchLink = regExp.exec(link);

  return matchLink ? link : `https://${link}`;
};

export default prepareOutsideLink;
